import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/shared/Common";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");

  const save = async () => {
    try {
      await api.patch("/auth/profile", { name, phone });
      toast.success("Profile updated");
      refresh();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <PageHeader title="Profile" subtitle="Manage your identity and preferences" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 border rounded-md bg-card p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="eyebrow text-muted-foreground">Name</Label>
              <Input data-testid="profile-name-input" value={name} onChange={e => setName(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label className="eyebrow text-muted-foreground">Email</Label>
              <Input value={user?.email} disabled className="mt-1.5 mono text-xs" />
            </div>
            <div>
              <Label className="eyebrow text-muted-foreground">Phone</Label>
              <Input data-testid="profile-phone-input" value={phone} onChange={e => setPhone(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label className="eyebrow text-muted-foreground">Role</Label>
              <Input value={user?.role} disabled className="mt-1.5 capitalize" />
            </div>
          </div>
          <Button data-testid="profile-save-btn" onClick={save}>Save changes</Button>
        </div>
        <div className="border rounded-md bg-card p-6">
          <div className="eyebrow text-muted-foreground mb-3">About</div>
          <div className="w-16 h-16 rounded-md bg-primary/10 text-primary grid place-items-center display text-2xl font-semibold mb-3">
            {user?.name?.[0]}
          </div>
          <div className="font-semibold">{user?.name}</div>
          <div className="text-xs text-muted-foreground mono">{user?.email}</div>
          <div className="text-[10px] uppercase tracking-widest text-primary mt-2">{user?.role}</div>
        </div>
      </div>
    </div>
  );
}
